import {HIDE_QUOTA_PAYWALL, SHOW_QUOTA_PAYWALL} from './actionTypes';

export const showQuotaPaywall = details => ({
  type: SHOW_QUOTA_PAYWALL,
  payload: details || {},
});

export const hideQuotaPaywall = () => ({type: HIDE_QUOTA_PAYWALL});
